export const UPDATE_USER_ACTIVITY = () => `userActivity/updateActivity`;
export const GET_USER_ACTIVITIES = () => `userActivity/getActivity`;
